export class ModuleSelection {
  ModuleId: number;
  Name: string;
  IsActive: boolean;
  IsChecked: boolean;
  TransactionFee?: number;
  RefundCost?: number;

  constructor(moduleId: number, name: string, isActive: boolean, isChecked: boolean, transactionFee: number = null, refundCost: number = null) {
    this.ModuleId = moduleId;
    this.Name = name;
    this.IsActive = isActive;
    this.IsChecked = isChecked;
    this.TransactionFee = transactionFee;
    this.RefundCost = refundCost;
  }
}
